import React, { createContext, useContext } from "react"

import { Project } from "shared/types/Project"
import { SelectOption } from "shared/types/Select"
import { FormContextValue } from "shared/ui/form/FormContext"

import { FloorModel } from "features/floor-management/types/FloorModel"

export interface FloorFormContextValue extends FormContextValue {
  positionOptions?: SelectOption<number>[]
  isLoadingPositionOptions?: boolean
  roomOptions?: SelectOption<string>[]
  isLoadingRoomOptions?: boolean
  projectOptions?: SelectOption<string, Project>[]
  isLoadingProjectOptions?: boolean
  hideProject?: boolean
  hidePosition?: boolean
  hideRemark?: boolean
  hideClarificationRequest?: boolean
  hideAttachments?: boolean
  model?: FloorModel | null
}

const FloorFormContext = createContext<FloorFormContextValue | undefined>(
  undefined
)

export interface FloorFormProviderProps {
  value: FloorFormContextValue
  children: React.ReactNode
}

export const FloorFormProvider = React.memo(
  ({ value, children }: FloorFormProviderProps) => (
    <FloorFormContext.Provider value={value}>
      {children}
    </FloorFormContext.Provider>
  )
)

export function useFloorFormContext(): FloorFormContextValue {
  const context = useContext(FloorFormContext)
  if (!context) {
    throw new Error(
      "useFloorFormContext must be used within a FloorFormProvider"
    )
  }
  return context
}
